import { render, staticRenderFns } from "./list.vue?vue&type=template&id=356471e8&scoped=true&"
import script from "./list.vue?vue&type=script&lang=js&"
export * from "./list.vue?vue&type=script&lang=js&"
import style0 from "./list.vue?vue&type=style&index=0&id=356471e8&prod&lang=less&scoped=true&"
import style1 from "./list.vue?vue&type=style&index=1&id=356471e8&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356471e8",
  null
  
)

export default component.exports